import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  MdDashboard,
  MdExpandMore,
  MdExpandLess,
  MdHome,
} from "react-icons/md";

export function SidebarLinks({ routes, collapsed }) {
  const location = useLocation();
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [tooltipVisible, setTooltipVisible] = useState(null);

  const activeRoute = (routeName) => location.pathname.includes(routeName);

  const toggleDropdown = (group) => {
    setOpenDropdowns((prev) => ({ ...prev, [group]: !prev[group] }));
  };

  const filterRoutes = (routes) => {
    const currentLayout = location.pathname.split("/")[1];
    return routes.filter(
      (route) =>
        route.layout.includes(currentLayout) && route.showInSidebar !== false
    );
  };

  const isGroupActive = (groupRoutes) =>
    groupRoutes.some((route) => activeRoute(route.path));

  const groupedRoutes = filterRoutes(routes).reduce((acc, route) => {
    const group = route.group || "General";
    acc[group] = acc[group] || [];
    acc[group].push(route);
    return acc;
  }, {});

  const showTooltip = (index) => setTooltipVisible(index);
  const hideTooltip = () => setTooltipVisible(null);

  return (
    <div className="w-full rounded-md bg-white p-2 dark:bg-navy-700">
      {Object.entries(groupedRoutes).map(([group, groupRoutes], index) => (
        <div key={index} className="mb-1">
          {/* Group Header */}
          {group !== "General" && (
            <button
              onClick={() => toggleDropdown(group)}
              className={`flex w-full items-center ${
                collapsed ? "justify-center" : "justify-between"
              } rounded-md  px-3 py-2.5 text-sm font-medium transition-colors ${
                isGroupActive(groupRoutes)
                  ? "bg-indigo-600 text-white dark:bg-navy-700 dark:text-white"
                  : "border border-b-indigo-600 text-gray-700  hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
              }`}
              onMouseEnter={() => collapsed && showTooltip(`group-${index}`)}
              onMouseLeave={hideTooltip}
            >
              {!collapsed ? (
                <>
                  <span className="truncate uppercase">{group}</span>
                  {openDropdowns[group] ? (
                    <MdExpandLess className="text-lg" />
                  ) : (
                    <MdExpandMore className="text-lg" />
                  )}
                </>
              ) : (
                <>
                  {groupRoutes[0]?.icon || <MdDashboard className="text-lg" />}
                  {/* Custom tooltip */}
                  {tooltipVisible === `group-${index}` && (
                    <div className="absolute left-full ml-2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs font-medium text-white shadow-lg">
                      {group}
                    </div>
                  )}
                </>
              )}
            </button>
          )}

          {/* Group Links */}
          <div
            className={`transition-all duration-300 ease-in-out ${
              openDropdowns[group] || group === "General"
                ? "max-h-screen opacity-100"
                : "max-h-0 overflow-hidden opacity-0"
            }`}
          >
            {groupRoutes.map((route, idx) => (
              <div
                key={idx}
                className="relative my-1"
                onMouseEnter={() => collapsed && showTooltip(`route-${idx}`)}
                onMouseLeave={hideTooltip}
              >
                <Link
                  to={`${route.layout}/${route.path}`}
                  className={`flex items-center gap-3 ${
                    collapsed ? "justify-center" : ""
                  } rounded-md px-3  py-2.5 transition-colors ${
                    activeRoute(route.path)
                      ? "bg-indigo-50 font-medium  text-indigo-700 dark:bg-indigo-800 dark:text-white"
                      : "text-gray-700 hover:bg-gray-100  dark:text-gray-300 dark:hover:bg-gray-700"
                  }`}
                >
                  <span className="text-xl">{route.icon || <MdHome />}</span>
                  {!collapsed && <span className="truncate">{route.name}</span>}
                  {activeRoute(route.path) && !collapsed && (
                    <div className="absolute left-0 top-0 h-full w-1 rounded-r-md bg-indigo-600" />
                  )}
                </Link>
                {/* Custom tooltip */}
                {tooltipVisible === `route-${idx}` && collapsed && (
                  <div className="absolute left-full ml-2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs font-medium text-white shadow-lg">
                    {route.name}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default SidebarLinks;
